import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export enum UserState {
	ViewingAsGuest,
	LoggedIn,
	TokenExpired,
}

interface CurrentUserState {
	userState: UserState;
	userType: string | null;
	userName?: string;
}

const initialState: CurrentUserState = {
	userState: UserState.ViewingAsGuest,
	userType: null,
	userName: "",
};

export const currentUserSlice = createSlice({
	name: "currentUser",
	initialState,
	reducers: {
		tokenExpired: state => {
			state.userState = UserState.TokenExpired;
			state.userType = null;
			sessionStorage.removeItem("token");
			sessionStorage.removeItem("refreshToken");
			sessionStorage.removeItem("reduxState");
		},
		logOut: state => {
			state.userState = UserState.ViewingAsGuest;
			state.userType = null;
			state.userName = "";
			sessionStorage.removeItem("token");
			sessionStorage.removeItem("refreshToken");
			sessionStorage.removeItem("reduxState");
		},
		logIn: (state, payload: PayloadAction<{ token: string; userType: string; refreshToken: string }>) => {
			state.userState = UserState.LoggedIn;
			state.userType = payload.payload.userType;
			sessionStorage.setItem("token", payload.payload.token);
			sessionStorage.setItem("refreshToken", payload.payload.refreshToken);
		},
		updateUsername: (state, payload: PayloadAction<{ userName: string }>) => {
			state.userName = payload.payload.userName;
		},
		viewAsGuest: state => {
			state.userState = UserState.ViewingAsGuest;
			state.userType = null;
		},
	},
});

export const { logOut, logIn, viewAsGuest, tokenExpired, updateUsername } = currentUserSlice.actions;

export default currentUserSlice.reducer;
